import { render, staticRenderFns } from "./CaseClosingNotification.vue?vue&type=template&id=57206f97&"
import script from "./CaseClosingNotification.vue?vue&type=script&lang=js&"
export * from "./CaseClosingNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports